import { Notifications, NotificationsActive } from '@mui/icons-material';
import { Badge } from '@mui/material';
import { FC, useContext } from 'react';
import { Link } from 'react-router-dom';
import { NewsNotificationContext } from '../../context/news-notification';
// components

interface INotificationBadgeProps {}

export const NotificationBadge: FC<INotificationBadgeProps> = ({ ...props }) => {
  const news = useContext(NewsNotificationContext);

  const hasUnreadNewsItems = news.unreadNewsItemCount > 0;
  return (
    <Link to={'/news'} style={{ textDecoration: 'none' }}>
      <Badge badgeContent={news.unreadNewsItemCount} showZero={false} color="secondary">
        {hasUnreadNewsItems ? (
          <NotificationsActive color="primary" />
        ) : (
          <Notifications color="action" />
        )}
      </Badge>
    </Link>
  );
};
